let infoSliders = document.querySelectorAll('[data-card-slider="info-slider"]');

infoSliders.forEach(infoSlider => {
  jQuery(infoSlider.querySelector('.slider-container')).slick({
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 5 / 2,
    slidesToScroll: 1,
    arrows: true,
    rows: 0,
    prevArrow: jQuery(infoSlider).find('.info-slider-prev'),
    nextArrow: jQuery(infoSlider).find('.info-slider-next'),
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1.5,
        }
      },
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });
});
